export { Divider, IDividerProps } from 'native-base';
